// import React from "react";
// import { Modal, Row, Col, Card } from "antd";

// const ModelDisplay = ({ selectedPolicy, isModalVisible, handleModalClose }) => {
//   return (
//     <Modal
//       title={`Policy Details - ${selectedPolicy?.policy_number || "N/A"}`}
//       open={isModalVisible}
//       onCancel={handleModalClose}
//       footer={null}
//       width={800}
//     >
//       {selectedPolicy ? (
//         <Row gutter={[16, 16]}>
//           {Object.entries(selectedPolicy).map(([key, value]) => (
//             <Col xs={24} sm={12} md={8} key={key}>
//               <Card title={key} bordered>
//                 {Array.isArray(value) ? (
//                   value.map((item, index) => <div key={index}>{item}</div>)
//                 ) : (
//                   <div>{value}</div>
//                 )}
//               </Card>
//             </Col>
//           ))}
//         </Row>
//       ) : (
//         <p>Loading policy details...</p>
//       )}
//     </Modal>
//   );
// };

// export default ModelDisplay;

// import React from "react";
// import { Modal, Row, Col, Card } from "antd";
// import { CloseOutlined } from "@ant-design/icons";

// const ModalDisplay = ({ selectedPolicy, isModalVisible, handleModalClose }) => {
//   return (
//     <Modal
//       title={`Policy Details - ${selectedPolicy?.policy_number || "N/A"}`}
//       open={isModalVisible}
//       onCancel={handleModalClose}
//       footer={null}
//       width={800}
//     >
//       {selectedPolicy ? (
//         <Row gutter={[16, 16]}>
//           {Object.entries(selectedPolicy).map(([key, value]) => (
//             <Col xs={24} sm={12} md={8} key={key}>
//               <Card
//                 className="card-header"
//                 title={key}
//                 headStyle={{ background: "pink" }}
//                 bordered
//               >
//                 {value ? (
//                   Array.isArray(value) ? (
//                     value.map((item, index) => <div key={index}>{item}</div>)
//                   ) : (
//                     <div>{value}</div>
//                   )
//                 ) : (
//                   <div>NA</div>
//                 )}
//               </Card>
//             </Col>
//           ))}
//         </Row>
//       ) : (
//         <p>Loading policy details...</p>
//       )}
//     </Modal>
//   );
// };

// export default ModalDisplay;

import React from "react";
import { Modal, Row, Col, Card, Divider, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import "./Modal.css"; // Import the CSS file

const ModalDisplay = ({ selectedPolicy, isModalVisible, handleModalClose }) => {
  return (
    <Modal
      title={
        <>
          <div>
            Policy Details - {selectedPolicy?.policy_number || "N/A"} | Sum
            Insured: ₹{selectedPolicy?.sum_insured || "N/A"}
          </div>
          <Divider style={{ margin: "10px 0" }} />
        </>
      }
      open={isModalVisible}
      onCancel={handleModalClose}
      footer={null}
      width={900}
      closable={false} // Disables the default close button
    >
      <span
        onClick={handleModalClose}
        style={{
          fontSize: "24px",
          fontWeight: "bold",
          cursor: "pointer",
          position: "absolute",
          right: "20px",
          top: "10px",
          zIndex: 1000,
        }}
      >
        ✕
      </span>
      {selectedPolicy?.details && selectedPolicy?.details.length > 0 ? (
        <Row gutter={[16, 16]}>
          {selectedPolicy.details.map((item, index) => (
            <Col xs={24} sm={12} md={8} key={index}>
              <Card
                title={
                  <span>
                    {item.ref_policy_feature_template_field_name
                      ? item.ref_policy_feature_template_field_name.length > 18
                        ? item.ref_policy_feature_template_field_name.slice(0, 18) + "..."
                        : item.ref_policy_feature_template_field_name
                      : "Field Name"}
                    {item.field_description && item.field_description.length > 0 && (  
                    <Tooltip title={item.field_description || "No additional info"}>
                      <InfoCircleOutlined style={{ color: "#fff", marginLeft: 8, verticalAlign: "text-bottom" }} />
                    </Tooltip>)}
                  </span>
                }
                headStyle={{
                  background: "#0072bb",
                  fontWeight: "bold",
                  color: "#fff",
                  border: "1px solid #0072bb",
                }}
                bordered
                style={{ height: "100%", border: "1px solid #0072bb" }}
              >
                {/* Render only the value as a string */}
                {item.policy_feature_template_field_value || "NA"}
              </Card>
            </Col>
          ))}
        </Row>
      ) : (
        <p>No policy details available.</p>
      )}
    </Modal>
  );
};

export default ModalDisplay;
